
import {Component, Prop, Vue} from "vue-property-decorator";
import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
import {bus} from "@/plugins/bus";
import {httpResource} from "@/resources/http.resource";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {isMobile} from "mobile-device-detect";
import {IApp} from "@/interfaces/app.interface";
import moment from "moment";
import ListSettings from "@/modules/barriers/components/ListSettings.vue";
import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";
import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";
import {gateActionsHelper, IGateActionItem} from "@/modules/barriers/helpers/gate-actions.helper";

  @Component({
    components: {ListSettings}
  })
  export default class GateActions extends Vue {
    @Prop() value: boolean;
    @Prop() parkId: number;
    @Prop() gate: Barrier.Entity;

    carNumberMode = Barrier.CarNumberMode;
    isMobile = isMobile;
    visibleDropdown = false;

    get displayChangeOrder() { return this.value; }
    set displayChangeOrder(value) { this.$emit('input', value); }

    get actionList(): IGateActionItem[] { return gateActionsHelper.getActionList(this.gate); }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

    async openBarrier(item: Barrier.Entity) {
      if (item.mode === Barrier.CarNumberMode.NoCar) {
        await this.openGateForMoto(item);
        return;
      }

      bus.$emit(Barrier.BusEvents.StopLoadingBarriers);
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'barriers',
        dialogName: 'openBarrier',
        payload: {
          barrier: item,
          noticeAction: (success) => this.displayOpenNotice(success),
          closeAction: async () => {
            bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
          },
        }
      });
    }

    async openGateForMoto(barrier: Barrier.Entity) {
      if (!this.userAccess.scMotocycle || (this.userAccess.scMotocycle && barrier.mode !== this.carNumberMode.NoCar)) return;

      let asyncAction = async () => {
        const params: any = { cameraId: barrier.camId };
        let success = await httpResource.httpAction({ action: Barrier.Action.OpenGateMoto, params });
        this.displayOpenNotice(success);
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    displayOpenNotice(success) {
      if (success) {
        this.$notify({
          title: 'Успешно',
          message: 'Шлагбаум успешно открыт',
          type: 'success'
        });
      }
      else {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте снова',
        });
      }
    }

    async gateActionClick(gateAction: IGateActionItem) {
      this.visibleDropdown = false;
      await gateAction.actionClick();
    }

    async openTrailer(barrier: Barrier.Entity) {
      this.visibleDropdown = false;
      bus.$emit(Barrier.BusEvents.StopLoadingBarriers);

      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'barriers',
        dialogName: 'trailerPopup',
        payload: {
          gate: barrier,
          closeAction: async () => {
            bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
          },
        },
      });
    }

    async openTrailCard() {
      this.visibleDropdown = false;
      bus.$emit(Barrier.BusEvents.StopLoadingBarriers);

      let payload: ICarStore.IPopupPayload = {
        carId: this.gate.trailerId,
        closeAction: async () => {
          bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
        },
      };
      await this.$store.dispatch('car/openCarPopup', payload);
    }

    async openLastPhoto(barrier: Barrier.Entity) {
      bus.$emit(Barrier.BusEvents.StopLoadingBarriers);
      const resourcePayload: ICamsPhoto.IPayloadCams = {
        camId: barrier.camId,
        lastPhotoFlag: true,
      };
      const { response } = await ICamsPhoto.GetCamsPhoto(resourcePayload);
      const mediaPayload: IAppMediaPopup.IPayload = {
        files: response && response.length ? response : [],
      };
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'allPages',
        dialogName: 'appMediaPopup',
        payload: {
          ...mediaPayload,
          closeAction: () => {
            bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
          }
        },
      });
    }
  }
